import React, { Suspense } from 'react';

const DelayedAllCampaignTypeSelectionStep =
  React.lazy(() => import(/* webpackChunkName: "all-campaign-type-selection-step.async" */ './all-campaign-type-selection-step')
    .then(({ AllCampaignTypeSelectionStepWithI18n }) => ({ default: AllCampaignTypeSelectionStepWithI18n })));

export const DelayedAllCampaignTypeSelectionStepWithI18n = () => (
  <Suspense fallback={null}>
    <DelayedAllCampaignTypeSelectionStep />
  </Suspense>
);
